import common from '@/locales/ru/common';
import components from '@/locales/ru/components';

export default {
  ...common,
  ...components,
};
